/**
 * 密码哈希工具函数
 * 使用 SHA-256 对密码进行客户端哈希处理
 * 注意：这只是第一层保护，后端会进行二次哈希
 */

/**
 * 将字符串转换为 SHA-256 哈希值
 * @param message 要哈希的字符串
 * @returns 十六进制格式的哈希值
 */
export async function sha256(message: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

/**
 * 对密码进行客户端哈希处理
 * 将前缀加到密码前，然后一起哈希，截取前16位
 * @param password 原始密码
 * @returns 哈希后的密码（前16位）
 */
export async function hashPassword(password: string): Promise<string> {
  // 将前缀加到原始密码前，然后一起哈希，截取前16位
  const fullHash = await sha256(`zhimianguan-yyds-fighting${password}`);
  return fullHash.slice(0, 16);
}
